// extracted by mini-css-extract-plugin
export default {"loader":"mbz907_0cIp2NuCBe3dt","rotate":"Nq0Wj4psWDfLiYjmNnTO"};